import { Skeleton } from 'antd';
import './TaskDetailSkeleton.css';

const TaskDetailSkeleton: React.FC = () => {
  return (
    <div className="task-skeleton-container">
      {/* Task Banner Skeleton */}
      <div className="task-skeleton-banner">
        <div className="task-skeleton-banner-info">
          <div className="task-skeleton-image">
            <Skeleton.Image active style={{ width: '300px', height: '200px' }} />
          </div>
          <div className="task-skeleton-content">
            <div className="task-skeleton-title">
              <Skeleton.Input active style={{ width: '60%', height: '40px' }} />
            </div>
            <div className="task-skeleton-description">
              <Skeleton active paragraph={{ rows: 3, width: ['100%', '85%', '70%'] }} title={false} />
            </div>
          </div>
        </div>
      </div>

      {/* Content Skeleton */}
      <div className="task-skeleton-content-section">
        <div className="task-skeleton-submissions-header">
          <Skeleton.Input active style={{ width: '200px', height: '32px' }} />
        </div>
        
        {/* Submission Cards Skeleton */}
        <div className="task-skeleton-submissions">
          {[1, 2, 3].map((index) => (
            <div key={index} className="task-skeleton-submission-card">
              <div className="task-skeleton-submission-header">
                <div className="task-skeleton-avatar">
                  <Skeleton.Avatar active size={40} />
                </div>
                <div className="task-skeleton-user-info">
                  <Skeleton.Input active style={{ width: '120px', height: '20px' }} />
                  <Skeleton.Input active style={{ width: '80px', height: '16px' }} />
                </div>
              </div>
              <div className="task-skeleton-submission-content">
                <Skeleton active paragraph={{ rows: 2, width: ['100%', '75%'] }} title={false} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TaskDetailSkeleton;